import { useEffect, useState } from "react";
import { Link2 } from "lucide-react";
import { toast } from "sonner";
import { api, errMsg } from "../../lib/api";
import { AthletePicker } from "../AthletePicker";
import { Field } from "../common";
import { Dialog, DialogContent, DialogHeader, DialogTitle } from "../ui/dialog";

export const LinkProfileButton = ({ user, onDone }) => {
  const [open, setOpen] = useState(false);
  const [profiles, setProfiles] = useState([]);
  const [sel, setSel] = useState("");
  const [busy, setBusy] = useState(false);
  useEffect(() => {
    if (!open) return;
    setSel("");
    api.get("/athletes").then((r) => {
      const list = r.data.filter((a) => a.manual);
      setProfiles(list);
      const guess = list.find((a) => a.name.toLowerCase() === (user.name || "").toLowerCase());
      if (guess) setSel(guess.user_id);
    });
  }, [open, user.name]);
  const link = async () => {
    if (!sel) return toast.error("Selecione o perfil");
    setBusy(true);
    try {
      await api.post(`/admin/users/${user.user_id}/link`, { profile_id: sel });
      toast.success("Login conectado ao perfil e aprovado!");
      setOpen(false);
      onDone();
    } catch (e) { toast.error(errMsg(e)); } finally { setBusy(false); }
  };
  return (
    <>
      <button data-testid={`link-profile-${user.user_id}`} onClick={() => setOpen(true)} className="btn-ghost flex items-center gap-1 text-[#E4F222]"><Link2 className="h-4 w-4" />Conectar a perfil</button>
      <Dialog open={open} onOpenChange={setOpen}>
        <DialogContent className="border-[#232B3E] bg-[#121722] sm:max-w-md">
          <DialogHeader><DialogTitle className="h-display text-3xl">Conectar login a um perfil</DialogTitle></DialogHeader>
          <div className="space-y-4">
            <div className="rounded-xl border border-[#232B3E] p-3 text-sm">
              <div className="font-semibold">{user.name}</div>
              <div className="text-xs text-[#94A3B8]">{user.email}</div>
              <div className="mt-1 text-xs text-[#94A3B8]">{[user.phone, user.ct_name, user.level, user.court_side].filter(Boolean).join(" · ")}</div>
            </div>
            <Field label="Perfil criado por você (sem login)">
              <AthletePicker testid="link-profile-picker" athletes={profiles} value={sel} onChange={setSel} placeholder={profiles.length ? "Selecionar perfil" : "Nenhum perfil sem login"} />
            </Field>
            <p className="text-xs text-[#64748B]">O perfil passa a usar este e-mail do Google. Pontos, inscrições e cobranças do perfil são mantidos; os dados que estiverem vazios no perfil são completados com o que a pessoa preencheu.</p>
            <button disabled={busy} data-testid="link-profile-confirm" onClick={link} className="btn-lime w-full rounded-full py-3">{busy ? "Conectando..." : "Conectar e aprovar"}</button>
          </div>
        </DialogContent>
      </Dialog>
    </>
  );
};
